import React from "react";
import { useState } from "react";
import "./TnsReady.css";
import BookDemoModal from "./BookDemoModal";

const features = [
  {
    icon: "/assets/TnsReady-booking.svg",
    title: "Faster bookings",
  },
  {
    icon: "/assets/TnsReady-service.svg",
    title: "Stronger customer service",
  },
  {
    icon: "/assets/TnsReady-gain.svg",
    title: "Real TnsReady gains",
  },
];

function TnsReady() {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <section className="section-padding">
        <div className="TnsReady-box">
          <h2 className="TnsReady-title " style={{ color: "white" }}>
            Ready to Transform Your Travel Business?
          </h2>

          <div
            className="read-btn-a"
            style={{
              margin: "0 auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => setShowModal(true)}
          >
            <button className="read-btn">
              <span>BOOK A DEMO</span>
              <img src="/assets/arrow.svg" alt="arrow" className="btn-arrow" />
            </button>
          </div>
        </div>
      </section>

      <BookDemoModal show={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default TnsReady;
